import { useContext } from 'react';

import { SessionContext } from '../session-context.js';

/**
 * Read the current session and its actions.
 *
 * @returns {import('../session-context.js').SessionValue}
 * @throws {Error} when used outside a SessionProvider, so a component in the wrong
 *   tree fails in development rather than quietly rendering as signed out.
 */
export function useSession() {
  const value = useContext(SessionContext);
  if (!value) throw new Error('useSession must be called inside a SessionProvider');
  return value;
}
